import Cart from "./Cart";
import Cactus from "./Cactus";
import Mask from "./Mask";
import Tube from "./Tube";
import Hers from "./Hers";
import Hims from "./Hims";
import Uniqlo from "./Uniqlo";
import Roche from "./Roche";
import Moon from "./Moon";
import Sun from "./Sun";
import Shopify from "./Shopify";

export default {
  Cart,
  Cactus,
  Hers,
  Hims,
  Mask,
  Moon,
  Roche,
  Shopify,
  Sun,
  Tube,
  Uniqlo
};
